export default "__VITE_ASSET__9d6222ad__"